var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIconFilled = function SvgSearchIconFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1873 6.56185C15.8653 6.56185 15.6039 6.82318 15.6039 7.14518C15.6039 7.46718 15.8653 7.72852 16.1873 7.72852C18.4389 7.72852 20.2706 9.56018 20.2706 11.8118C20.2706 12.1338 20.5319 12.3952 20.8539 12.3952C21.1759 12.3952 21.4373 12.1338 21.4373 11.8118C21.4373 8.91706 19.0821 6.56185 16.1873 6.56185ZM16.1873 2.47852C11.0408 2.47852 6.85393 6.66539 6.85393 11.8118C6.85393 14.1755 7.73885 16.3353 9.19281 17.9815L2.64985 24.5244C2.42206 24.7522 2.42206 25.1215 2.64985 25.3493C2.76389 25.4633 2.91293 25.5202 3.06226 25.5202C3.2116 25.5202 3.36064 25.4633 3.47468 25.3493L10.0176 18.8063C11.6635 20.2603 13.8236 21.1452 16.1873 21.1452C21.3337 21.1452 25.5206 16.9583 25.5206 11.8118C25.5206 6.66539 21.3337 2.47852 16.1873 2.47852Z",
    fill: "black",
    fillOpacity: 0.8
  })));
};
export default SvgSearchIconFilled;